import { cn } from "@newxsystems/shared";
import { SproutAction } from "../SproutAction/SproutAction";
import { SproutMedia } from "../SproutMedia/SproutMedia";
import { SproutRichText } from "../SproutRichText/SproutRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-5", centered && "items-center text-center")}>
      {eyebrow ? (
        <p className="w-fit -rotate-1 rounded-lg bg-whiteboard px-3 py-2 font-sprout-mono text-sm font-extrabold text-navy-ink">
          {eyebrow}
        </p>
      ) : null}
      {image ? (
        <SproutMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-3", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="max-w-[16ch] font-sprout-display text-4xl font-bold leading-[0.98] tracking-[-0.025em] [overflow-wrap:anywhere] md:text-6xl">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <SproutRichText className="max-w-[65ch] text-navy-ink" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <SproutAction action={button} key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
